import * as React from 'react'

const NoMatch = () => (
  <div>
    <div className='row'>
      <div className='card col s12 m6 offset-m3'>
        <div className='card-content center-align'>
          <img
            className='responsive-img'
            src={require('../images/travolta.jpg')}
            alt='Confused Travolta'
            style={{ maxHeight: '200px' }}
          />
          <br />
          We likely messed up a link or something.<br />Contact us at{' '}
          <a href='mailto:support@innovaptor.com?subject=[Ginfo] Feedback'>
            support@innovaptor.com
          </a>{' '}
          so we can fix it!
        </div>
      </div>
    </div>
  </div>
)

export default NoMatch



// WEBPACK FOOTER //
// ./src/pages/404.tsx